(() => {
  if (window.d1PdpReadmoreLoaded) return;
  window.d1PdpReadmoreLoaded = true;

  const controllers = new WeakMap();

  const revealTarget = (target) => {
    if (!target) return;
    const section = target.closest('[data-d1-pdp-readmore]');
    const controller = controllers.get(section);
    if (!controller) return;
    if (controller.description?.contains(target)) controller.expand();

  };

  const revealHash = () => {
    try {
      revealTarget(document.getElementById(decodeURIComponent(location.hash.slice(1))));
    } catch (_) {}
  };

  const initialize = (section) => {
    if (controllers.has(section)) return;
    const description = section.querySelector('#description');
    const controller = { description, expand: () => {} };
    controllers.set(section, controller);
    if (!description || !description.textContent.trim()) return;

    const body = document.createElement('div');
    body.className = 'd1-pdp-more__body';
    body.id = `D1PdpDescription-${section.dataset.d1PdpReadmore}`;
    const content = document.createElement('div');
    content.className = 'd1-pdp-more__content';
    while (description.firstChild) content.append(description.firstChild);
    body.append(content);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn--primary d1-pdp-more__button';
    button.setAttribute('aria-controls', body.id);
    button.hidden = true;
    description.append(body, button);
    description.classList.add('d1-pdp-more');

    let expanded = false;
    let frame = 0;
    const setExpanded = (value) => {
      expanded = value;
      description.toggleAttribute('data-expanded', expanded);
      if (expanded) body.scrollTop = 0;
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? section.dataset.readLess : section.dataset.readMore;
    };
    controller.expand = () => setExpanded(true);

    const measure = () => {
      frame = 0;
      const limit = Math.round(window.innerHeight * 1.5);
      description.style.setProperty('--d1-pdp-preview-height', `${limit}px`);
      const collapsible = content.getBoundingClientRect().height > limit + 80;
      description.toggleAttribute('data-collapsible', collapsible);
      button.hidden = !collapsible;
    };
    const scheduleMeasure = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };

    button.addEventListener('click', () => {
      setExpanded(!expanded);
      if (!expanded) requestAnimationFrame(() => {
        if (button.getBoundingClientRect().top < 100) {
          button.scrollIntoView({ block: 'center', behavior: 'instant' });
        }
      });
    });
    content.addEventListener('focusin', (event) => {
      if (!expanded && event.target.getBoundingClientRect().bottom - content.getBoundingClientRect().top > body.clientHeight - 80) {
        setExpanded(true);
        event.target.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      }
    });
    content.addEventListener('load', scheduleMeasure, true);
    window.addEventListener('resize', scheduleMeasure);
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleMeasure);
      observer.observe(content);
      controller.observer = observer;
    }
    document.fonts?.ready.then(scheduleMeasure);
    controller.cleanup = () => {
      window.removeEventListener('resize', scheduleMeasure);
      controller.observer?.disconnect();
      cancelAnimationFrame(frame);
    };
    setExpanded(false);
    measure();
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-d1-pdp-readmore]').forEach(initialize);
    revealHash();
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    try {
      revealTarget(document.getElementById(decodeURIComponent(url.hash.slice(1))));
    } catch (_) {}
  });
  document.addEventListener('beforematch', (event) => revealTarget(event.target));
  document.addEventListener('keydown', (event) => {
    if (!(event.ctrlKey || event.metaKey) || event.altKey || event.key.toLowerCase() !== 'f') return;
    document.querySelectorAll('[data-d1-pdp-readmore]').forEach((section) => {
      controllers.get(section)?.expand();
    });
  });
  window.addEventListener('hashchange', revealHash);
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-d1-pdp-readmore]').forEach((section) => controllers.get(section)?.cleanup?.());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();
})();


